module.exports = __webpack_public_path__ + "static/media/tran.ca1bb353.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tran.svg
// module id = 398
// module chunks = 0